<template>
    <div class="player-container">
        <div class="left-float">
            <img class="close-player" :src="close" alt="close" @click="stop">
            <img class="cover-icon" :src="currentSong.img ? currentSong.img : placeholder" alt="cover-thumbnail"/>
            <div class="song-details">
                <p class="song-name">{{ currentSong.title }}</p>
                <p class="artist-name">{{ currentSong.artist }}</p>
            </div>
        </div>
        <div>
            <div class="progress-container">
                <p class="time-stamp current-time">{{ currentTime }}</p>
                <v-progress-linear
                    v-model="progressPercentage"
                    style="width: 400px;"
                    height="5"
                    color="#fcb61a"
                    background-color="#fff"
                    @click.native="setPosition()"
                    :disabled="!songLoaded"
                >
                </v-progress-linear>
                <p class="time-stamp total-time">{{ formattedDuration }}</p>
            </div>
        </div>
        <div class="player-button-container">
                <div v-if="isPlaying" @click="pause">
                    <img
                        class="pause-icon"
                        src="../assets/image/pause-icon.png"
                        alt="pause"
                    />
                </div>
                <div v-else @click="play">
                    <img
                        class="pause-icon"
                        src="../assets/image/play.png"
                        alt="play"
                    />
                </div>
             <div v-if="!songDownloadable">
                <img
                    v-if="liked"
                    class="heart-icon"
                    src="../assets/image/heart-liked-icon.png"
                    alt="liked"
                    @click="likeSong"
                />
                <img
                    v-else
                    class="heart-icon"
                    src="../assets/image/heart-icon.png"
                    alt="heart"
                    @click="likeSong"
                />
            </div>
            <div v-if="songDownloadable" @click.prevent="onClickDownload">
                <img class="player-download" src="../assets/image/download@3x.png" alt="download"/>
            </div>
        </div>
        <audio id="player" ref="player" :src="currentSong.songFile"></audio>
    </div>
</template>

<script>
    import { db } from '../config/firebaseInit';
    import { environment } from '../constants';
    import downloadUrl from '../util';
    const close = require('../assets/image/close.png');
    export default {
        name: 'MusicPlayerFooter',
        props: {
            song: {
                type: Object,
            },
            isVisible: {
                type: Boolean,
                default: false
            },
            songList: {
                type: Array
            },
            songIndex: {
                type: Number
            },
            onClosePlayer: {
                type: Function
            },
            returnSongFromPlayer: {
                type: Function
            },
            songDownloadable: {
              type: Boolean,
              default: false
            }
        },
        data() {
            return {
                isPlaying: true,
                isPaused: false,
                liked: false,
                currentTime: '0:00',
                duration: 0,
                progressPercentage: 0,
                songLoaded: true,
                currentSong: this.song,
                currentSongIndex: this.songIndex,
                placeholder: require('../assets/image/album-cover-placeholder.jpg'),
                close
            }
        },
        computed: {
            formattedDuration: function() {
                return this.formatTime(this.duration);
            },
        },
        watch: {
            song: function() {
                this.currentSong = this.song;
                this.currentSongIndex = this.songIndex;
                this.liked = this.song.liked;
                this.$nextTick(() => {
                    this.play();
                });
            }
        },
        methods: {
            formatTime (seconds) {
                return new Date(seconds * 1000).toISOString().substr(15, 4)
            },
            setPosition () {
                this.audio.currentTime = parseInt(this.audio.duration / 100 * this.progressPercentage);
            },
            play() {
                /*eslint no-unused-vars:*/
                this.audio.play().then(_ => {
                    this.isPlaying = true;
                    this.isPaused = false
                });
            },
            pause() {
                this.isPaused = true;
                this.isPlaying = false;
                this.audio.pause();
            },
            stop() {
                this.audio.pause();
                this.isPaused = true;
                this.isPlaying = false;
                this.audio.currentTime = 0;
                this.returnSongFromPlayer();
                this.onClosePlayer();
            },

            likeSong() {
                let songRef = db.collection(`${environment}-submissions`).doc(this.currentSong.id);
                return db.runTransaction((transaction) => {
                    return transaction.get(songRef).then((songDoc) => {
                        let newLikes = 0;
                        if(this.liked === false) {
                            this.liked = true;
                            newLikes = songDoc.data().likes + 1;
                        } else {
                            this.liked = false;
                            newLikes = songDoc.data().likes - 1;
                        }
                        transaction.update(songRef, {likes: newLikes});
                    });
                }).then(() => {
                    this.currentSong = { ...this.currentSong, liked: this.liked };
                    this.songList[this.currentSongIndex] = this.currentSong;
                }).catch((error) => {
                    console.log('an error occurred when liking: ', error);
                })
            },

            onClickDownload() {
                downloadUrl(this.currentSong.songFile);
            },
            _handleLoaded: function () {
                if (this.audio.readyState >= 2) {
                    this.duration = parseInt(this.audio.duration);
                    this.songLoaded = true;
                } else {
                    throw new Error('Failed to load sound file')
                }
            },
            _handlePlayingUI: function () {
                this.progressPercentage = this.audio.currentTime / this.audio.duration * 100;
                this.currentTime = this.formatTime(this.audio.currentTime);
            },
            _handleEnded () {
                if(this.songList.length === 0) {
                    this.stop();
                    return;
                }
                this.currentSongIndex += 1;
                if(this.currentSongIndex >= this.songList.length) {
                    this.currentSongIndex = 0;
                }
                this.currentSong = this.songList[this.currentSongIndex];
                this.returnSongFromPlayer(this.currentSong, this.currentSongIndex);
                this.$nextTick(() => {
                    this.play();
                })
            },
            _handlePlayPause: function(e) {
                if (e.type === 'pause' && this.isPaused === false && this.isPlaying === false) {
                    this.currentTime = '0:00';
                }
            },
            init: function () {
                this.audio.addEventListener('pause', this._handlePlayPause);
                this.audio.addEventListener('play', this._handlePlayPause);
                this.audio.addEventListener('timeupdate', this._handlePlayingUI);
                this.audio.addEventListener('loadeddata', this._handleLoaded);
                this.audio.addEventListener('ended', this._handleEnded);
            },
        },
        mounted() {
            this.audio = this.$refs.player;
            this.init();
            this.play();
        },
        beforeDestroy () {
            this.audio.removeEventListener('pause', this._handlePlayPause);
            this.audio.removeEventListener('play', this._handlePlayPause);
            this.audio.removeEventListener('timeupdate', this._handlePlayingUI);
            this.audio.removeEventListener('loadeddata', this._handleLoaded);
            this.audio.removeEventListener('ended', this._handleEnded);
        }
    }
</script>

<style>
    .player-container {
        background-color: black;
        height: 110px;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
    }

    .cover-icon {
        width: 80px;
        height: 80px;
        border-radius: 6px;
        object-fit: cover;
    }

    .left-float {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }

    .song-details {
        display: flex;
        flex-direction: column;
        margin-left: 25px;
        margin-top: 15px;
        justify-content: center;
    }

    .song-name {
        font-size: 17px;
        color: white;
        letter-spacing: 0px;
        line-height: 0.5;
    }

    .artist-name {
        font-size: 15px;
        color: white;
        letter-spacing: 0px;
        line-height: 0.5;
    }

    .progress-container {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
    }

    .time-stamp {
        color: white;
    }

    .current-time {
        margin-right: 10px;
        margin-top: 15px;
        font-family: 'Lato-Regular', sans-serif;
        font-size: 15px;
    }

    .total-time {
        margin-left: 10px;
        margin-top: 15px;
        font-family: 'Lato-Regular', sans-serif;
        font-size: 15px;
    }

    .player-button-container {
        display: flex;
        flex-direction: row;
        width: 10%;
        justify-content: space-between;
        align-items: center;
    }

    .pause-icon {
        width: 29px;
        height: 37px;
        object-fit: contain;
        cursor: pointer;
    }

    .pause-icon:hover {
        opacity: 0.8;
    }

    .heart-icon {
        width: 39px;
        height: 34px;
        object-fit: contain;
        cursor: pointer;
    }

    .heart-icon:hover {
        opacity: 0.8;
    }

    .close-player {
        width: 20px;
        height: 15px;
        margin-right: 30px;
        cursor: pointer;
    }

    .player-download {
        width: 46px;
        height: 30px;
    }

    @media only screen and (max-width: 640px) {
        .player-container {
            justify-content: space-around;
            height: 75px;
        }

        .progress-container {
            display: none;
        }

        .player-button-container {
            width: 20%;
        }

        .cover-icon {
            width: 38px;
            height: 38px;
        }

        .artist-name, .song-name {
            font-size: 12px;
        }

        .song-name {
            line-height: 0;
        }

        .heart-icon {
            width: 24px;
            height: 22px;
        }

        .pause-icon {
            width: 20px;
            height: 29px;
        }

        .close-player {
            width: 14px;
            height: 11px;
            margin-right: 20px;
        }

        .player-download {
            width: 38px;
            height: 25px;
        }
    }

    @media only screen and (min-width: 641px) and (max-width: 768px) {
        .progress-container {
            width: 300px;
        }

        .player-button-container {
            width: 15%;
        }
    }

    @media only screen and (min-width: 769px) and (max-width: 1000px) {
        .progress-container {
            width: 350px;
        }

        .pause-icon, .heart-icon {
            margin: 0 10px;
        }
    }
</style>